// extracted by mini-css-extract-plugin
module.exports = {"codeBlockContainer":"CodeBlock_codeBlockContainer__yMOol","header":"CodeBlock_header__vSWaq","codeBlock":"CodeBlock_codeBlock__sHUES"};